module.exports = __webpack_public_path__ + "static/media/HelveticaNeue.c951bd08.ttf";